/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 * @return {object} The parsed JSON, status from the response
 */
export const parseJSON = <T>(response: T): Promise<T> => {
    // @ts-ignore
    return new Promise((resolve) => response.json()
        .then((json: any) => resolve({
            // @ts-ignore
            status: response.status,
            // @ts-ignore
            ok: response.ok,
            json,
        }))
        .catch(() => resolve({
            // @ts-ignore
            status: response.status,
            // @ts-ignore
            ok: response.ok,
            json: {},
        }))
    );
};
